import { IconIconOnDark, IconIconOnLight, TextCtaLink, Size5, Size4, Size3 } from '@box/blueprint-web-assets/tokens/tokens';

var getIconSize = function getIconSize(buttonSize, isIconButton) {
  var size;

  if (isIconButton) {
    size = buttonSize === 'large' ? Size5 : Size4;
  } else {
    size = buttonSize === 'large' ? Size4 : Size3;
  }

  return {
    width: size,
    height: size
  };
};

var loadingIndicatorVariantMap = {
  primary: 'light',
  secondary: 'default',
  tertiary: 'default',
  outline: 'dark'
};
var buttonVariantToIconColorMap = {
  primary: IconIconOnDark,
  secondary: IconIconOnLight,
  tertiary: TextCtaLink,
  outline: IconIconOnLight
};
export { buttonVariantToIconColorMap, getIconSize, loadingIndicatorVariantMap };